import axios from "axios";
import APIURL from "../../../Main/apiurl";

export const get_ar_report = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-ar-report`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data || { success: false, message: error.message };
  }
};

export const get_customer_invoices = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-customer-invoices`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data || { success: false, message: error.message };
  }
};